const FRAME_WIDTH = 375;
const FRAME_HEIGHT = 812;
const FRAME_TOP_DIFFERENCE = 110;
const FRRAME_BOTTOM_DIFFERENCE = 35;
const MAIN_STAGE_HEIGHT = FRAME_HEIGHT - FRAME_TOP_DIFFERENCE - FRRAME_BOTTOM_DIFFERENCE;
const PLAYER_START_X = FRAME_WIDTH / 2;
const PLAYER_START_Y = MAIN_STAGE_HEIGHT / 2 - FRAME_TOP_DIFFERENCE;
const GRID_UNIT = FRAME_WIDTH / 8;

export default {
  FRAME_WIDTH,
  FRAME_HEIGHT,
  FRAME_TOP_DIFFERENCE,
  FRRAME_BOTTOM_DIFFERENCE,
  MAIN_STAGE_HEIGHT,
  PLAYER_START_X,
  PLAYER_START_Y,
  GRID_UNIT,
};
